import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { capitalize } from '../../../containers/Pages/Edd/EddUtils';

const ITEM_HEIGHT = 80;
const CONTAINER_HEIGHT = 725;
const OVERSCAN = 5;

export function EddErrorInfo(props) {
  const { fileDetails, errorViewClicked } = props;
  const errors = fileDetails.errorsToDisplay;
  const [scrollTop, setScrollTop] = useState(0);
  const handleScroll = useCallback(e => setScrollTop(e.currentTarget.scrollTop), []);
  const startIndex = Math.max(0, Math.floor(scrollTop / ITEM_HEIGHT) - OVERSCAN);
  const endIndex = Math.min(
    errors.length - 1,
    Math.ceil((scrollTop + CONTAINER_HEIGHT) / ITEM_HEIGHT) + OVERSCAN,
  );
  const virtualItems = [];

  for (let i = startIndex; i <= endIndex; i += 1) {
    virtualItems.push(i);
  }

  return (
    <div className="visible border-none border-4 border-green-200 w-[30%] 2xl:w-[35%] ">
      <div className="w-full pb-2  mt-8 z-40 shadow-[20px_20px_60px_#bebebe_-10px_-20px_60px_#ffffff] shadow-[#bebebe] ">
        <div
          onScroll={handleScroll}
          className="w-full  h-[725px] bg-white/30 backdrop-blur-[24px] outline-solid outline-white  overflow-y-auto"
        >
          <div className=" flex justify-between border-b-[1px]  pb-2">
            <p className="font-bold text-dark-night mt-6 ml-6  items-center">Error Information</p>
            <div className="flex ">
              <p
                aria-label="error-count"
                className="font-bold text-dark-night mt-6 ml-6  items-center"
              >
                {`${errors.length}  ${errors.length > 1 ? 'rows' : 'row'} with ${errors.length > 1 ? 'errors' : ' an error'} `}
              </p>

              <img
                src="/assets/images/icons/help-hexagon.svg"
                alt="error info"
                className="w-[24px] h-[24px] max-w-[24px] max-h-[24px] mt-6 ml-6 mr-6"
              />
            </div>
          </div>

          <div className="[overflow-anchor:none]">
            <div style={{ height: startIndex * ITEM_HEIGHT }} />
            {virtualItems.map(i => {
              const el = errors[i];

              return (
                <div
                  key={el.id}
                  className="flex items-center ml-2 2xl:ml-6 2xl:mr-6 mr-2 mt-4 border-b-[1px] pb-2"
                >
                  <img
                    src="/assets/images/icons/bug.svg"
                    alt="Error"
                    className="w-[24px] h-[24px] max-w-[24px] max-h-[24px]"
                  />
                  <div className="mt-1 ml-2 2xl:ml-8 overflow-hidden">
                    <p className="font-semibold text-dark-night text-sm">{el.title}</p>
                    {el.descriptionParts.map(part => (
                      <p
                        key={part.id}
                        className="font-semibold text-slate-600 text-xs max-w-64 mt-1 break-words"
                        data-test="edd-error-description"
                      >
                        {capitalize(part.value)}
                      </p>
                    ))}
                  </div>
                  <button
                    type="button"
                    className=" flex ml-2 2xl:ml-8 active:bg-slate-300
                                bg-primary text-white cursor-pointer
                                font-semibold hover:scale-x-105 hover:scale-y-105 duration-200   hover:bg-orange-500 h-8 rounded-md justify-start items-center  p-2 "
                    onClick={errorViewClicked}
                  >
                    <p className="text-sm text-inherit">View</p>

                    <i className="material-icons !text-inherit !text-[20px]">arrow_downward</i>
                  </button>
                </div>
              );
            })}
            <div style={{ height: Math.max(0, (errors.length - endIndex - 1) * ITEM_HEIGHT) }} />
          </div>
        </div>
      </div>
    </div>
  );
}

EddErrorInfo.propTypes = {
  fileDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  errorViewClicked: PropTypes.func,
};
